module.exports = __webpack_public_path__ + "frontend-assets/img/ab_plus_consent_big.cd80c9bc.jpg";